import axios from "@/api/http";

export function init(token,data) {
  return axios({
    url: '/api/processApproval/init',
    method: 'POST',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function submit(token,data) {
  return axios({
    url: '/api/processApproval/submit',
    method: 'POST',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function download(token, data) {
  return axios({
    method: 'post',
    url: '/api/processApproval/download',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function editProduct(token, data) {
  return axios({
    url: '/api/processApproval/editProduct',
    method: 'POST',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function retrial(token, pid) {
  return axios({
    url: '/api/processApproval/retrial/' + pid,
    method: 'GET',
    headers: {
      'authorization': token
    }
  })
}
